import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  background: ${({ theme }) => theme.palette.common.white};
`;

export const Header = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 27px */
  letter-spacing: 0.15px;
  margin: 16px 20px 16px 20px;
  padding: 0;
`;

export const GridContainer = styled.div`
  margin: 16px 20px 20px 20px;
`;
